import { Trans } from "@lingui/react/macro";
import { BigMessageView } from "../../base/views/BigMessageView";
import React from "react";

export const ErrorView = () => (
  <BigMessageView
    banner="logo"
    title={<Trans id="page.error.title">Es ist ein Fehler aufgetreten</Trans>}
    text={
      <Trans id="page.error.message">
        Hier geht es zurück zum <a href="/">Start</a>
      </Trans>
    }
  />
);
